<template>
    <div>
        <div class="form-group col-12">
            <label for="header">Header</label>
            <input
                id="header"
                v-model="termsOfUse.header"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('header')
                }"
                dir="auto"
            />

            <div class="invalid-feedback">
                {{ getError('header') }}
            </div>
        </div>

        <div class="form-group col-12">
            <wysiwyg-editor
                v-model="termsOfUse.content"
                label="Content"
                :error-border="hasError('content')"
            />

            <div class="invalid-feedback">
                {{ getError('content') }}
            </div>
        </div>
    </div>
</template>

<script>
import WysiwygEditor from '@/components/elements/WysiwygEditor';

export default {
    components: {
        WysiwygEditor
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            termsOfUse: {}
        };
    },

    watch: {
        termsOfUse() {
            this.$emit('input', this.termsOfUse);
        }
    },

    mounted() {
        this.termsOfUse = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.termsOfUse[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.termsOfUse,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
